// extracted by mini-css-extract-plugin
export default {"Name":"LinkedName_Name__KM1Qf"};